import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GlobalsService } from '../../services/globals.service';
import { GlobalSearchService } from '../../services/globalsearchservice.service';

@Component({
	selector: 'app-gl-department-required',
	templateUrl: './gl-department-required.component.html',
	styleUrls: ['./gl-department-required.component.scss'],
})
export class GlDepartmentRequiredComponent implements OnInit {
	@ViewChild(MatSort) sort!: MatSort;
	@ViewChild(MatPaginator) paginator!: MatPaginator;

	color = 'blue';
	isLoading = false;
	savingCode: string | null = null;
	searchTerm = '';
	showOnlyRequired = false;

	dataSource = new MatTableDataSource<any>([]);
	allAccounts: any[] = [];
	displayedColumns = ['department_required', 'accountcode', 'accountname', 'group'];

	constructor(
		private globalsService: GlobalsService,
		private globalSearchService: GlobalSearchService,
		private snackBar: MatSnackBar
	) {
		this.color = this.globalSearchService.getColor();
	}

	ngOnInit(): void {
		this.loadAccounts();
	}

	loadAccounts(): void {
		this.isLoading = true;
		this.globalsService.getDepartmentRequiredAccounts().subscribe(
			(res: any) => {
				this.allAccounts = res?.accounts || [];
				this.applyFilter();
				this.isLoading = false;
			},
			() => {
				this.snackBar.open('Error loading accounts.', 'Close', { duration: 3000 });
				this.isLoading = false;
			}
		);
	}

	applyFilter(): void {
		const term = this.searchTerm.toLowerCase();
		let filtered = this.allAccounts;
		if (term) {
			filtered = filtered.filter(a =>
				a.accountcode.toLowerCase().includes(term) ||
				a.accountname.toLowerCase().includes(term) ||
				(a.group || '').toLowerCase().includes(term)
			);
		}
		if (this.showOnlyRequired) {
			filtered = filtered.filter(a => a.department_required == 1);
		}
		this.dataSource.data = filtered;
		setTimeout(() => {
			this.dataSource.sort = this.sort;
			this.dataSource.paginator = this.paginator;
		});
	}

	toggle(account: any, required: boolean): void {
		this.savingCode = account.accountcode;
		this.globalsService.setAccountDepartmentRequired(account.accountcode, required).subscribe(
			() => {
				account.department_required = required ? 1 : 0;
				this.savingCode = null;
				this.applyFilter();
			},
			() => {
				this.savingCode = null;
				this.snackBar.open('Failed to update account.', 'Close', { duration: 3000 });
			}
		);
	}

	back(): void {
		window.history.back();
	}
}
